'use client';

import React from 'react';
import { StudentLayout } from '@/layouts/Student';

const Layout = ({ children }: React.PropsWithChildren) => (
  <StudentLayout>{children}</StudentLayout>
);

export default Layout;
